// extracted by mini-css-extract-plugin
module.exports = {"component":"Logos_component__0G4iW","heading":"Logos_heading___IlPC","logos":"Logos_logos__oEir0","logosFR":"Logos_logosFR__6ji3w","logoItem":"Logos_logoItem__VrqL5"};